module.exports = __webpack_public_path__ + "static/media/Gral_Mario_Guillermo_Fromow_Garcia.9996153d.jpg";